// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"97":"8705e70c","124":"23434099","191":"c1694bca","264":"5767780b","305":"139f0c5b","410":"73e936a3","429":"8eb889a1","480":"2e80b7cf","638":"2b9c9a6a","720":"d8ea1a74","799":"0a336c67","846":"a27d2f21"}[chunkId] + ".chunk.js";
};